import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import moment from 'moment';
import { MessageService } from 'primeng/api';
import { DatePickerModule } from 'primeng/datepicker';
import { ApplicationService } from 'src/app/private/services/application.service';
import { LeadService } from 'src/app/private/services/lead.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-add-enrollment',
  imports: [SharedModule, DatePickerModule],
  templateUrl: './add-enrollment.component.html',
  styleUrl: './add-enrollment.component.scss'
})
export class AddEnrollmentComponent {



  // leadForm
  @ViewChild('leadForm') leadForm: any;

  createFieldFormValue: any = {};
  fieldValues: any = {};
  previousLeadData: any = {};
  today: Date = new Date();

  isFixedColumn: boolean = true;
  isSubmitted: boolean = false;
  @Input() allLeadFeilds: any = [];
  @Input() users: any = [];
  @Input() editLeadData: any = {};
  @Output() reload = new EventEmitter<any>();
  @Input() isRegsiteration: boolean = false;
  @Input() formAction: any = 'Add';
  @Input() allCourses: any = [];
  isAdmin: boolean = true;
  isLoading: boolean = false;



  // preferredCourseList: any[] = [
  //   { label: 'B.Tech', value: '1' },
  //   { label: 'M.Tech', value: '2' },
  //   { label: 'BBA', value: '3' },
  //   { label: 'MBA', value: '4' },
  //   { label: 'BCA', value: '5' },
  //   { label: 'MCA', value: '6' },
  //   { label: 'B.Com', value: '7' },
  //   { label: 'M.Com', value: '8' },
  //   { label: 'B.Sc', value: '9' },
  //   { label: 'M.Sc', value: '10' },
  //   { label: 'Other', value: '11' }
  // ]

  documentStatusList = [
    { label: 'Verified', value: 'verified' },
    { label: 'Pending', value: 'pending' },
    { label: 'Rejected', value: 'rejected' }
  ];

  registrationStatusList: any[] = [
    { value: 'Pending', label: 'Pending' },
    { value: 'Under Review', label: 'Under Review' },
    { value: 'Accepted', label: 'Accepted' },
    { value: 'Rejected', label: 'Rejected' }
  ];

  modeOfStudyList: any[] = [
    { label: 'Online', value: 'Online' },
    { label: 'Offline', value: 'Offline' },
    { label: 'Hybrid', value: 'Hybrid' }
  ];


  constructor(
    private api: LeadService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  ngOnChanges() {

    this.isSubmitted = false;

    if (this.users && this.users.length > 0) {
      this.users = this.users.map((user: any) => {
        return {
          label: user.fname + " " + user.lname,
          value: user?.user_id
        }
      });
    }

    if (this.editLeadData) {
      this.createFieldFormValue = this.editLeadData;
      this.createFieldFormValue.contact_phone = this.createFieldFormValue.phone;
      this.fieldValues = this.editLeadData.dynamic_fields || {};
      this.previousLeadData = JSON.parse(JSON.stringify(this.editLeadData));
    }

    this.createFieldFormValue.reg_data = {};
    this.createFieldFormValue.application_data = {};
    this.createFieldFormValue.enrollment_data = {};

  }

  leadSources: any[] = [
    { label: 'Channel Partner', value: 'Channel Partner' },
    { label: 'Conference', value: 'Conference' },
    { label: 'Field Visit', value: 'Field Visit' },
    { label: 'Google', value: 'Google' },
    { label: 'Instagram', value: 'Instagram' },
    { label: 'Lead Gen Tools', value: 'Lead Gen Tools' },
    { label: 'Live Session', value: 'Live Session' },
    { label: 'Personal', value: 'Personal' },
    { label: 'Referral', value: 'Referral' },
    { label: 'LinkedIn', value: 'LinkedIn' },
    { label: 'Website', value: 'Website' },
    { label: 'WhatsApp', value: 'WhatsApp' },
    { label: 'Tina', value: 'Tina' },
    { label: 'Intern', value: 'Intern' },
    { label: 'Other', value: 'Other' }
  ];

  leadTypes: any[] = [
    { label: 'New Lead', value: 'New Lead' },
    { label: 'Cold Lead', value: 'Cold Lead' },
    { label: 'Warm Lead', value: 'Warm Lead' },
    { label: 'Hot Lead', value: 'Hot Lead' }
  ];

  leadStatusList: any[] = [
    { value: 'In Progress', label: 'In Progress' },
    { value: 'Completed', label: 'Completed' },
    { value: 'Canceled', label: 'Canceled' }
  ];

    enrollmentStatusList: any[] = [
    { value: 'Under Review', label: 'Under Review' },
    { value: 'In Progress', label: 'In Progress' },
    { value: 'Completed', label: 'Completed' },
    { value: 'Canceled', label: 'Canceled' }
  ];


  queryTypes: any[] = [
    { label: 'General', value: 'General' },
    { label: 'Admission', value: 'Admission' },
    { label: 'Application', value: 'Application' },
    { label: 'Fee Structure', value: 'Fee Structure' },
    { label: 'Registration', value: 'Registration' },
    { label: 'Placement', value: 'Placement' },
    { label: 'Alumni', value: 'Alumni' },
    { label: 'Course', value: 'Course' },
    { label: 'Other', value: 'Other' }
  ];

  genderOptions: any[] = [
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' },
    { label: 'Other', value: 'Other' }
  ];

  prefixOptions: any[] = [
    { label: 'Mr', value: 'Mr' },
    { label: 'Mrs', value: 'Mrs' },
    { label: 'Miss', value: 'Miss' },
    { label: 'Dr', value: 'Dr' },
    { label: 'Prof', value: 'Prof' }
  ];

  @Output() closeDialog = new EventEmitter<any>();

  handleCloseDialog() {
    this.closeDialog.emit();
  }



  // onSubmit(isValid: any) {
  //   this.isSubmitted = true;
  //   if (!isValid) {
  //     this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill all the required fields' });
  //     return;
  //   }


  //   this.isLoading = true;
  //   // if (this.createFieldFormValue.valid) {
  //   //   this.api.createLead(this.fieldValues).subscribe((res: any) => {
  //   //     if (res.success) {
  //   //       this.localStorage.set('leadFields', res.data);
  //   //       this.closeDialog.emit();
  //   //     }
  //   //   });
  //   // }
  // }




  onSubmit(isValid: any) {

    this.isSubmitted = true;
    if (!isValid) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill all the required fields' });
      return;
    }

    if (this.allLeadFeilds && this.allLeadFeilds.length > 0) {
      for (let field of this.allLeadFeilds) {
        if (field.required && !this.fieldValues[field.field_name]) {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: `${field.field_label} is required` });
          return;
        }
      }
    }

    if (isValid) {
      if (this.formAction == 'Add') {
        this.isSubmitted = true;
        this.isLoading = true;
        this.createFieldFormValue.organization_id = this.localStorage.getOrganizationId();
        this.createFieldFormValue.campus_id = this.localStorage.getCampusId();
        this.createFieldFormValue.user_id = this.localStorage.getUserId();
        this.createFieldFormValue.dynamic_fields = this.fieldValues;
        this.createFieldFormValue.lead_date = moment().format('YYYY-MM-DD');
        this.createFieldFormValue.lead_time = moment().format('HH:mm');
        this.createFieldFormValue.phone = this.createFieldFormValue.contact_phone;

        this.createFieldFormValue.current_stage = 'enrollment';
        this.createFieldFormValue.enrollment_data.user_id = this.localStorage.getUserId();

        this.api.addLeadData(this.createFieldFormValue).subscribe({
          next: (c) => {
            this.isLoading = false;
            // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Lead Added Successfully' });
            this.reload.emit();
            this.createFieldFormValue = {};
            this.fieldValues = {};
            this.isSubmitted = false;
            this.previousLeadData = {};

            if (this.isRegsiteration) {
              this.createFieldFormValue.reg_data = {};
            }

            // reset the form
            this.leadForm.resetForm();

            this.closeDialog.emit();
          },
          error: (e) => {
            this.isLoading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong' });
          },
          complete: () => { },
        });
      } else if (this.formAction == 'Update') {

        this.isSubmitted = true;
        this.isLoading = true;
        this.createFieldFormValue.dynamic_fields = this.fieldValues;
        this.createFieldFormValue.phone = this.createFieldFormValue.contact_phone;

        this.createFieldFormValue.old_lead_data = this.previousLeadData;

        this.api.updateLead(this.createFieldFormValue).subscribe({
          next: (c) => {
            this.isLoading = false;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Lead Updated Successfully' });
            this.createFieldFormValue = {};
            this.fieldValues = {};
            this.previousLeadData = {};
            this.isSubmitted = false;
            this.reload.emit();
            this.closeDialog.emit();
          },
          error: (e) => {
            this.isLoading = false;
            this.isSubmitted = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong' });
          },
          complete: () => { },
        });
      }
      // console.log(this.lead)
    }
  }

  

}
